<div class="row" *ngIf="this.caseTypeId">
  <div class="col-lg-3">
    <div class="space"></div>
    <div class="sidebar" [ngClass]="{ 'fullscreen-card': isFullscreen }">
      <div class="sidebar-list">
        <div
          *ngFor="let item of filteredSidebarItems"
          class="sidebar-card sidebar-item"
          [ngClass]="{ active: selectedSidebarItem?.key === item.key }"
          (click)="onSelectSidebarItem(item)"
          role="button"  tabindex="-1"
        >
          <div class="sidebar-row">
            <div class="item-icon text-white" [ngClass]="item.bgColor">
              <i [class]="item.icon"></i>
              <span
                *ngIf="item?.changed"
                class="badge badge-circle badge-sm badge-warning p-1 mb-2"
              ></span>
            </div>

            <div class="item-info">
              <span
                class="item-title"
                [ngClass]="{ active: selectedSidebarItem?.key === item.key }"
                >{{ item.label | translate }}</span
              >
              <span
                class="item-description"
                [ngClass]="{ active: selectedSidebarItem?.key === item.key }"
                >{{ item.description | translate }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-9" *ngIf="selectedSidebarItem">
    @if (isReadOnly) {
    <div style="margin-left: auto" class="space d-flex justify-content-end align-items-center gap-2">
      <div class="user-badges-container">
        <div class="user-badge editor">
          <i class="fas fa-pen"></i>
          {{ userInFile }}
          <span>(Düzenleyici)</span>
        </div>
      </div>
    
      <!-- Düzenlemeyi devral -->
       @if (userInFile !== loggedInUsername) {
      <button
        class="btn btn-sm btn-primary"
        (click)="takeOverEdit()">
        Düzenlemeyi Devral
      </button>
    }
    </div>

    } @else {
    <div class="space d-flex case-tab-container">
      <div
        class="tab-item-card"
        *ngFor="let tab of filteredTabs"
        (click)="handleTabClick($event, tab, menu)"
        role="button"  tabindex="-1"
      >
        <i
          [style.color]="tab.color"
          class="fa fa-solid d-flex justify-content-center"
          [ngClass]="tab.icon"
        ></i>
        <div class="text-center">{{ tab.label | translate }}</div>
      </div>

      <p-menu #menu [model]="actionMenuModel" appendTo="body" [popup]="true">
        <ng-template pTemplate="submenuheader" let-item>
          <div class="my-submenu-header">
            <i *ngIf="item.icon" [ngClass]="item.icon" class="me-2"></i>
            <span>{{ item.label }}</span>
          </div>
        </ng-template>
      </p-menu>
    </div>
    }

    <div
      class="card content-container"
      [ngClass]="{ 'fullscreen-card': isFullscreen }"
      [ngSwitch]="selectedSidebarItem.key"
    >
      <app-patient-informations
        *ngSwitchCase="'patient-informations'"
        (formChanged)="formChanged()"
        #patientInformations
      ></app-patient-informations>

      <app-case-informations
        *ngSwitchCase="'case-informations'"
        (formChanged)="formChanged()"
        #caseInformations
      ></app-case-informations>

      <app-address-informations
        *ngSwitchCase="'address-informations'"
        (formChanged)="formChanged()"
        #addressInformations
      ></app-address-informations>
      <app-service-informations
        *ngSwitchCase="'service-informations'"
        (formChanged)="formChanged()"
        #serviceInformations
      ></app-service-informations>
      <app-case-calls
        *ngSwitchCase="'call-informations'"
        #caseCalls
        [callCardInformations]="selectCallCardInformations"
      ></app-case-calls>
      <app-payment-informations
        *ngSwitchCase="'payment-informations'"
        (formChanged)="formChanged()"
        #paymentInformations
      ></app-payment-informations>

      <app-inspectation-informations
        *ngSwitchCase="'inspection-informations'"
        (formChanged)="formChanged()"
        [caseId]="caseId"
        #inspectationInformations
      ></app-inspectation-informations>
      <!-- <app-cerebral-informations
        *ngIf="patient?.id"
        [patientId]="patient.id"
        [caseId]="caseId"
        *ngSwitchCase="'cerebral-informations'"
      ></app-cerebral-informations> -->
      <ng-container *ngSwitchCase="'cerebral-informations'">
        <app-cerebral-informations *ngIf="patient?.id" [patientId]="patient.id" [caseId]="caseId"></app-cerebral-informations>
      </ng-container>
    </div>
  </div>
</div>

<app-case-surveys
  [caseId]="caseId"
  [caseTypeId]="caseTypeId"
  [patient]="patient"
  [patientPhones]="patientPhones"
  #caseSurveysComponent
>
</app-case-surveys>

<p-dialog
  [(visible)]="showValidationErrorPopup"
  [modal]="true"
  [closable]="false"
  [style]="{ width: '40%' }"
>
  <p-header>
    <i class="fa-solid fa-circle-exclamation" style="color: #edb335"></i>
    {{ "case.validation.header" | translate }}
  </p-header>
  <div class="p-dialog-content">
    <p class="dialog-warning-header">
      {{ "case.validation.description" | translate }}
    </p>
    <ol class="steps-list">
      <ul class="required-fields-list">
        <li *ngFor="let field of caseValidationInformation?.validationErrors">
          {{ field }}
        </li>
      </ul>
    </ol>
  </div>

  <p-footer>
    <div class="dialog-button-container" (click)="validationPopupClose()" role="button"  tabindex="-1">
      <button
        pButton
        [label]="'patient-mobile.location-sharing.ok' | translate"
        icon="pi pi-check"
        class="p-button-success"
      ></button>
    </div>
  </p-footer>
</p-dialog>

<app-case-send-sms #caseSms></app-case-send-sms>
<app-case-send-email #caseEmail></app-case-send-email>
<app-case-timeline #timeline></app-case-timeline>
<app-case-assign-vehicle #assignVehicle></app-case-assign-vehicle>
<app-case-vehicle-status-timeline
  #vehicleTimeline
></app-case-vehicle-status-timeline>
<app-case-documents #caseDocument></app-case-documents>

<app-case-epicrisis #reportEpicrisis></app-case-epicrisis>

<app-case-cancel #caseCancel></app-case-cancel>
<app-case-feature-informations
  #caseFeaturesComponent
></app-case-feature-informations>
<app-case-bill-list #caseBills></app-case-bill-list>

<app-assign-user-dialog #assignUser></app-assign-user-dialog>

